"use strict";
/** ******************************************************************************
 *  (c) 2019 Sandblock
 *  (c) 2019 ZondaX GmbH
 *  (c) 2016-2017 Ledger
 *
 *  Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 *  You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software
 *  distributed under the License is distributed on an "AS IS" BASIS,
 *  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *  See the License for the specific language governing permissions and
 *  limitations under the License.
 ******************************************************************************* */

var _regeneratorRuntime = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/enguerrand/Dev/Sandblock/surprise-chain-explorer/client/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var js_sha256_1 = require("js-sha256");

var RIPEMD160 = require("crypto-js/ripemd160");

var bech32 = require("bech32");

var CLA = 0x55;
var CHUNK_SIZE = 250;
var INS = {
  GET_VERSION: 0x00,
  PUBLIC_KEY_SECP256K1: 0x01,
  SIGN_SECP256K1: 0x02,
  SHOW_ADDR_SECP256K1: 0x03,
  GET_ADDR_SECP256K1: 0x04
};
var ERROR_DESCRIPTION = {
  1: 'U2F: Unknown',
  2: 'U2F: Bad request',
  3: 'U2F: Configuration unsupported',
  4: 'U2F: Device Ineligible',
  5: 'U2F: Timeout',
  14: 'Timeout',
  0x9000: 'No errors',
  0x9001: 'Device is busy',
  0x6400: 'Execution Error',
  0x6700: 'Wrong Length',
  0x6982: 'Empty Buffer',
  0x6983: 'Output buffer too small',
  0x6984: 'Data is invalid',
  0x6985: 'Conditions not satisfied',
  0x6986: 'Transaction rejected',
  0x6A80: 'Bad key handle',
  0x6B00: 'Invalid P1/P2',
  0x6D00: 'Instruction not supported',
  0x6E00: 'Sandblock app does not seem to be open',
  0x6F00: 'Unknown error',
  0x6F01: 'Sign/verify error'
};

function errorCodeToString(statusCode) {
  if (statusCode in ERROR_DESCRIPTION) return ERROR_DESCRIPTION[statusCode];
  return "Unknown Status Code: ".concat(statusCode);
}

function getBech32FromPK(hrp, pk) {
  if (pk.length !== 33) {
    throw new Error('expected compressed public key [31 bytes]');
  }

  var hashSha256 = js_sha256_1.sha256(pk);
  var hashRip = RIPEMD160(hashSha256);
  return bech32.encode(hrp, bech32.toWords(hashRip));
}

exports.getBech32FromPK = getBech32FromPK;

function processErrorResponse(response) {
  return {
    return_code: response.statusCode,
    error_message: errorCodeToString(response.statusCode)
  };
}

function serializeHRP(hrp) {
  if (hrp == null || hrp.length < 3 || hrp.length > 83) {
    throw new Error('Invalid HRP');
  }

  var buf = Buffer.alloc(1 + hrp.length);
  buf.writeUInt8(hrp.length, 0);
  buf.write(hrp, 1);
  return buf;
}

function serializePath(path) {
  if (path == null || path.length < 3) {
    throw new Error('Invalid path.');
  }

  if (path.length > 10) {
    throw new Error('Invalid path. Length should be <= 10');
  }

  var buf = Buffer.alloc(1 + 4 * path.length);
  buf.writeUInt8(path.length, 0);

  for (var i = 0; i < path.length; i += 1) {
    var v = path[i];

    if (i < 3) {
      // eslint-disable-next-line no-bitwise
      v |= 0x80000000; // Harden
    }

    buf.writeInt32LE(v, 1 + i * 4);
  }

  return buf;
}

function compressPublicKey(publicKey) {
  if (publicKey.length !== 65) {
    throw new Error('decompressed public key length should be 65 bytes');
  }

  var y = publicKey.slice(33, 65); // eslint-disable-next-line no-bitwise,new-cap

  var z = Buffer.from([2 + (y[y.length - 1] & 1)]);
  return Buffer.concat([z, publicKey.slice(1, 33)]);
}

function signGetChunks(path, message) {
  var chunks = [];
  chunks.push(serializePath(path));
  var buffer = Buffer.from(message);

  for (var i = 0; i < buffer.length; i += CHUNK_SIZE) {
    var end = i + CHUNK_SIZE;

    if (i > buffer.length) {
      end = buffer.length;
    }

    chunks.push(buffer.slice(i, end));
  }

  return chunks;
}

exports.signGetChunks = signGetChunks;

var SandblockApp =
/*#__PURE__*/
function () {
  function SandblockApp(transport) {
    var scrambleKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'CSM';

    _classCallCheck(this, SandblockApp);

    if (typeof transport === 'undefined') {
      throw new Error('Transport has not been defined');
    }

    this.transport = transport;
    transport.decorateAppAPIMethods(this, ['getVersion', 'publicKey', 'sign', 'getAddressAndPubKey', 'appInfo', 'deviceInfo', 'getBech32FromPK'], scrambleKey);
  }

  _createClass(SandblockApp, [{
    key: "getVersion",
    value: function () {
      var _getVersion = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", this.transport.send(CLA, INS.GET_VERSION, 0, 0).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                  var targetId = 0;

                  if (response.length >= 9) {
                    /* eslint-disable no-bitwise */
                    targetId = (response[5] << 24) + (response[6] << 16) + (response[7] << 8) + (response[8] << 0);
                    /* eslint-enable no-bitwise */
                  }

                  return {
                    return_code: returnCode,
                    error_message: errorCodeToString(returnCode),
                    // ///
                    test_mode: response[0] !== 0,
                    major: response[1],
                    minor: response[2],
                    patch: response[3],
                    device_locked: response[4] === 1,
                    target_id: targetId.toString(16)
                  };
                }, processErrorResponse));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getVersion() {
        return _getVersion.apply(this, arguments);
      }

      return getVersion;
    }()
  }, {
    key: "appInfo",
    value: function () {
      var _appInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", this.transport.send(0xB0, 0x01, 0, 0).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                  var result = {};
                  var appName = 'err';
                  var appVersion = 'err';
                  var flagLen = 0;
                  var flagsValue = 0;

                  if (response[0] !== 1) {
                    // Ledger responds with format ID 1. There is no spec for any format != 1
                    //@ts-ignore
                    result.error_message = 'response format ID not recognized'; //@ts-ignore

                    result.return_code = 0x9001;
                  } else {
                    var appNameLen = response[1];
                    appName = response.slice(2, 2 + appNameLen).toString('ascii');
                    var idx = 2 + appNameLen;
                    var appVersionLen = response[idx];
                    idx += 1;
                    appVersion = response.slice(idx, idx + appVersionLen).toString('ascii');
                    idx += appVersionLen;
                    var appFlagsLen = response[idx];
                    idx += 1;
                    flagLen = appFlagsLen;
                    flagsValue = response[idx];
                  }

                  return {
                    return_code: returnCode,
                    error_message: errorCodeToString(returnCode),
                    // //
                    appName: appName,
                    appVersion: appVersion,
                    flagLen: flagLen,
                    flagsValue: flagsValue,
                    // eslint-disable-next-line no-bitwise
                    flag_recovery: (flagsValue & 1) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_signed_mcu_code: (flagsValue & 2) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_onboarded: (flagsValue & 4) !== 0,
                    // eslint-disable-next-line no-bitwise
                    flag_pin_validated: (flagsValue & 128) !== 0
                  };
                }, processErrorResponse));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function appInfo() {
        return _appInfo.apply(this, arguments);
      }

      return appInfo;
    }()
  }, {
    key: "deviceInfo",
    value: function () {
      var _deviceInfo = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", this.transport.send(0xE0, 0x01, 0, 0, Buffer.from([]), [0x9000, 0x6E00]).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];

                  if (returnCode === 0x6E00) {
                    return {
                      return_code: returnCode,
                      error_message: 'This command is only available in the Dashboard'
                    };
                  }

                  var targetId = response.slice(0, 4).toString('hex');
                  var pos = 4;
                  var secureElementVersionLen = response[pos];
                  pos += 1;
                  var seVersion = response.slice(pos, pos + secureElementVersionLen).toString();
                  pos += secureElementVersionLen;
                  var flagsLen = response[pos];
                  pos += 1;
                  var flag = response.slice(pos, pos + flagsLen).toString('hex');
                  pos += flagsLen;
                  var mcuVersionLen = response[pos];
                  pos += 1; // Patch issue in mcu version

                  var tmp = response.slice(pos, pos + mcuVersionLen);

                  if (tmp[mcuVersionLen - 1] === 0) {
                    tmp = response.slice(pos, pos + mcuVersionLen - 1);
                  }

                  var mcuVersion = tmp.toString();
                  return {
                    return_code: returnCode,
                    error_message: errorCodeToString(returnCode),
                    // //
                    targetId: targetId,
                    seVersion: seVersion,
                    flag: flag,
                    mcuVersion: mcuVersion
                  };
                }, processErrorResponse));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function deviceInfo() {
        return _deviceInfo.apply(this, arguments);
      }

      return deviceInfo;
    }()
  }, {
    key: "publicKey",
    value: function () {
      var _publicKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(path) {
        var serializedPath;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                serializedPath = serializePath(path);
                return _context4.abrupt("return", this.transport.send(CLA, INS.PUBLIC_KEY_SECP256K1, 0, 0, serializedPath).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                  var pk = Buffer.from(response.slice(0, 65));
                  return {
                    pk: pk,
                    compressed_pk: compressPublicKey(pk),
                    return_code: returnCode,
                    error_message: errorCodeToString(returnCode)
                  };
                }, processErrorResponse));

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function publicKey(_x) {
        return _publicKey.apply(this, arguments);
      }

      return publicKey;
    }()
  }, {
    key: "getAddressAndPubKey",
    value: function () {
      var _getAddressAndPubKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(path, hrp) {
        var data;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                data = Buffer.concat([serializeHRP(hrp), serializePath(path)]);
                return _context5.abrupt("return", this.transport.send(CLA, INS.GET_ADDR_SECP256K1, 0, 0, data, [0x9000]).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                  var compressedPk = Buffer.from(response.slice(0, 33));
                  var bech32Address = Buffer.from(response.slice(33, -2)).toString();
                  return {
                    bech32_address: bech32Address,
                    compressed_pk: compressedPk,
                    return_code: returnCode,
                    error_message: errorCodeToString(returnCode)
                  };
                }, processErrorResponse));

              case 2:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getAddressAndPubKey(_x2, _x3) {
        return _getAddressAndPubKey.apply(this, arguments);
      }

      return getAddressAndPubKey;
    }() // eslint-disable-next-line camelcase

  }, {
    key: "signSendChunk",
    value: function () {
      var _signSendChunk = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(chunk_idx, chunk_num, chunk) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.transport.send(CLA, INS.SIGN_SECP256K1, chunk_idx, chunk_num, chunk, [0x9000, 0x6A80]).then(function (response) {
                  var errorCodeData = response.slice(-2);
                  var returnCode = errorCodeData[0] * 256 + errorCodeData[1];
                  var errorMessage = errorCodeToString(returnCode);

                  if (returnCode === 0x6A80) {
                    errorMessage = response.slice(0, response.length - 2).toString('ascii');
                  }

                  var signature = null;

                  if (response.length > 2) {
                    signature = response.slice(0, response.length - 2);
                  }

                  return {
                    signature: signature,
                    return_code: returnCode,
                    error_message: errorMessage
                  };
                }, processErrorResponse));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function signSendChunk(_x4, _x5, _x6) {
        return _signSendChunk.apply(this, arguments);
      }

      return signSendChunk;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8() {
        var _this = this;

        var path,
            message,
            chunks,
            _args8 = arguments;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                path = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : [44, 118, 0, 0, 0];
                message = _args8.length > 1 ? _args8[1] : undefined;
                chunks = signGetChunks(path, message);
                return _context8.abrupt("return", this.signSendChunk(1, chunks.length, chunks[0]).then(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee7(response) {
                    var result, i;
                    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                      while (1) {
                        switch (_context7.prev = _context7.next) {
                          case 0:
                            result = {
                              return_code: response.return_code,
                              error_message: response.error_message,
                              signature: null
                            };
                            i = 1;

                          case 2:
                            if (!(i < chunks.length)) {
                              _context7.next = 11;
                              break;
                            }

                            _context7.next = 5;
                            return _this.signSendChunk(1 + i, chunks.length, chunks[i]);

                          case 5:
                            result = _context7.sent;

                            if (!(result.return_code !== 0x9000)) {
                              _context7.next = 8;
                              break;
                            }

                            return _context7.abrupt("break", 11);

                          case 8:
                            i += 1;
                            _context7.next = 2;
                            break;

                          case 11:
                            return _context7.abrupt("return", {
                              return_code: result.return_code,
                              error_message: result.error_message,
                              // ///
                              signature: result.signature
                            });

                          case 12:
                          case "end":
                            return _context7.stop();
                        }
                      }
                    }, _callee7);
                  }));

                  return function (_x7) {
                    return _ref.apply(this, arguments);
                  };
                }(), processErrorResponse));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function sign() {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "isAppOpen",
    value: function () {
      var _isAppOpen = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9() {
        var appInfo, appName;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.appInfo();

              case 2:
                appInfo = _context9.sent;
                appName = appInfo.appName;

                if (!(appName.toLowerCase() !== "sandblock")) {
                  _context9.next = 6;
                  break;
                }

                return _context9.abrupt("return", false);

              case 6:
                return _context9.abrupt("return", true);

              case 7:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function isAppOpen() {
        return _isAppOpen.apply(this, arguments);
      }

      return isAppOpen;
    }()
  }, {
    key: "versionString",
    value: function versionString(_ref2) {
      var major = _ref2.major,
          minor = _ref2.minor,
          patch = _ref2.patch;
      return "".concat(major, ".").concat(minor, ".").concat(patch);
    }
  }]);

  return SandblockApp;
}();

exports.default = SandblockApp;